import { useState } from "react";
import { X, Plus } from "lucide-react";
import { PHOTO } from "@/constants/testIds";

export default function TagEditor({ tags = [], onChange }) {
  const [value, setValue] = useState("");

  const add = () => {
    const t = value.trim().toLowerCase();
    if (!t) return;
    if (tags.includes(t)) { setValue(""); return; }
    onChange([...tags, t]);
    setValue("");
  };

  const remove = (t) => onChange(tags.filter((x) => x !== t));

  return (
    <div className="rounded-2xl bg-white border border-[#EAE2D6] p-4">
      <div className="text-xs uppercase tracking-wide text-[#6A606C] font-bold mb-2">Tags</div>
      <div className="flex flex-wrap items-center gap-1.5 mb-2">
        {tags.length === 0 && (
          <span className="font-hand text-lg text-[#6A606C]">no tags yet</span>
        )}
        {tags.map((t) => (
          <span
            key={t}
            className="inline-flex items-center gap-1 bg-[#F4EFE6] text-[#2D232E] text-sm font-semibold px-2.5 py-0.5 rounded-full"
          >
            #{t}
            <button
              type="button"
              onClick={() => remove(t)}
              className="hover:text-[#E76F51]"
              aria-label={`Remove tag ${t}`}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <input
          data-testid={PHOTO.tagInput}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder="add a tag..."
          className="flex-1 h-9 px-3 rounded-xl bg-[#FDFBF7] border border-[#EAE2D6] text-sm focus:outline-none focus:ring-2 focus:ring-[#E76F51]/40"
        />
        <button
          data-testid={PHOTO.tagAddBtn}
          type="button"
          onClick={add}
          className="h-9 w-9 rounded-full bg-[#E76F51] hover:bg-[#F4A261] text-white flex items-center justify-center"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
